import React from 'react'
import { Button, Col, Row, Spin } from 'antd'
import { BulbOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import mymatpic from '$assets/img/mymatpic.png'
import { fetchAllMaterials as fetchDwhMaterialsAPI } from '$api/evoAPIs'
import { fetchClientMaterialKPIs } from '$api/client'

const Topwelcomecard = ({ handleSuggestClick }) => {
  const { t } = useTranslation()

  const { data: clientKpis, isLoading: isLoadingClientKpis } = useQuery(
    ['clientMaterialKPIs'],
    fetchClientMaterialKPIs,
  )

  const { data: dwhMaterialsCount, isLoading: isLoadingDwhMaterials } =
    useQuery(
      ['dwhMaterialsListForKPIs'],
      () =>
        fetchDwhMaterialsAPI({
          queryKey: ['dwhMaterialsListForKPIs', { page: 1, size: 1 }],
        }),
      {
        select: (data) => data.total,
      },
    )

  const isLoading = isLoadingClientKpis || isLoadingDwhMaterials

  return (
    <Row className="myevocard">
      <Col
        xs={24}
        sm={8}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={mymatpic} width="135px" alt="My Materials Illustration" />
      </Col>
      <Col xs={24} sm={16}>
        <Row
          gutter={[16, 16]}
          style={{
            height: '100%',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Col style={{ width: '20%' }}>
            {t('kpi_unmapped_materials')}
            <h2>
              {isLoading ? (
                <Spin size="small" />
              ) : (
                (clientKpis?.unmapped_materials ?? 0)
              )}
            </h2>
          </Col>
          <Col style={{ width: '20%' }}>
            {t('kpi_client_materials')}
            <h2>
              {isLoading ? (
                <Spin size="small" />
              ) : (
                (clientKpis?.total_client_materials ?? 0)
              )}
            </h2>
          </Col>
          <Col style={{ width: '20%' }}>
            {t('kpi_dwh_materials')}
            <h2>
              {isLoading ? <Spin size="small" /> : (dwhMaterialsCount ?? 0)}
            </h2>
          </Col>
          <Col style={{ width: '35%' }}>
            <Button
              icon={<BulbOutlined />}
              type="primary"
              onClick={handleSuggestClick}
            >
              {t('my_materials.suggest_material_button')}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Topwelcomecard
